document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header__wrapper');
    if (header) {
        let lastScroll = 0;
        const defaultOffset = 200;
        const scrollPosition = () => window.scrollY || document.documentElement.scrollTop;
        window.addEventListener("scroll", () => {
            if (scrollPosition() > lastScroll && !header.classList.contains('header--sticky') && scrollPosition() > defaultOffset && !document.body.classList.contains('remove-scrolling')) {
                header.classList.add('header--sticky');
            } else if (scrollPosition() < lastScroll && header.classList.contains('header--sticky') && !document.body.classList.contains('remove-scrolling')) {
                header.classList.remove('header--sticky');
            }

            lastScroll = scrollPosition();
        });
    }
});